module.exports = __webpack_public_path__ + "static/media/NEWSEVENTS2.20c5f0f1.jpg";